import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function InventoryCounting() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
